import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle, X, ChevronRight, Phone } from "lucide-react";
import { useContent } from "@/context/ContentContext";

const OPTIONS = [
  { label: "Traiteur", desc: "Réceptions, cocktails, entreprises…", to: "/traiteur", service: "Traiteur uniquement" },
  { label: "Mariage ou cérémonie", desc: "Vin d'honneur, repas, cocktails", to: "/mariages", service: "Traiteur uniquement" },
  { label: "Cheffe à domicile", desc: "Dîner privé, couple, VIP", to: "/cheffe-a-domicile", service: "Cheffe à domicile" },
  { label: "Coordination événementielle", desc: "Jour J, prestataires, planning", to: "/coordination", service: "Coordination événementielle uniquement" },
  { label: "Entreprise ou institution", desc: "Séminaires, inaugurations", to: "/traiteur#entreprises", service: "Traiteur uniquement" },
  { label: "Catering et production", desc: "Tournages, spectacles, artistes", to: "/catering-production", service: "Traiteur uniquement" },
  { label: "Autre demande", desc: "Je souhaite être conseillée", to: "/devis", service: "Je souhaite être conseillée" },
];

export function ConversionAssistant() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { content } = useContent();
  const whatsapp = content?.contact?.whatsapp;
  const phone = content?.contact?.phone;

  const go = (opt) => {
    setOpen(false);
    try {
      window.dispatchEvent(new CustomEvent("ar_track", { detail: { event: "assistant_use", option: opt.label } }));
    } catch (e) {}
    navigate(opt.to);
  };

  return (
    <>
      {open && (
        <div
          data-testid="assistant-panel"
          className="fixed bottom-40 right-5 z-[60] w-[320px] max-w-[calc(100vw-2.5rem)] fade-up lg:bottom-24"
        >
          <div className="overflow-hidden rounded-2xl border border-[#2C2C2C]/10 bg-white shadow-2xl">
            <div className="bg-[#2C2C2C] px-5 py-4">
              <p className="font-serif text-lg text-white">Comment pouvons-nous vous aider ?</p>
              <p className="mt-1 text-xs text-[#FAF6EF]/70">Choisissez une orientation, nous vous guidons.</p>
            </div>
            <div className="max-h-[50vh] overflow-y-auto p-2 thin-scroll">
              {OPTIONS.map((o) => (
                <button
                  key={o.label}
                  data-testid={`assistant-opt-${o.label}`}
                  onClick={() => go(o)}
                  className="group flex w-full items-center justify-between gap-2 rounded-lg px-3 py-3 text-left transition-colors hover:bg-[#FAF6EF]"
                >
                  <span>
                    <span className="block text-sm font-medium text-[#2C2C2C]">{o.label}</span>
                    <span className="block text-xs text-[#2C2C2C]/55">{o.desc}</span>
                  </span>
                  <ChevronRight size={16} className="text-[#C9A84C] transition-transform group-hover:translate-x-1" />
                </button>
              ))}
            </div>
            <div className="border-t border-[#2C2C2C]/10 p-3">
              {whatsapp ? (
                <a href={whatsapp} target="_blank" rel="noreferrer" data-testid="assistant-whatsapp" className="flex items-center justify-center gap-2 rounded-lg bg-[#C9A84C] py-2.5 text-sm font-medium text-[#2C2C2C]">
                  <Phone size={15} /> Discuter sur WhatsApp
                </a>
              ) : (
                <a href={`tel:${(phone || "").replace(/\s/g, "")}`} data-testid="assistant-call" className="flex items-center justify-center gap-2 rounded-lg bg-[#C9A84C] py-2.5 text-sm font-medium text-[#2C2C2C]">
                  <Phone size={15} /> Nous appeler {phone}
                </a>
              )}
            </div>
          </div>
        </div>
      )}

      <button
        data-testid="assistant-toggle"
        onClick={() => setOpen((v) => !v)}
        aria-label="Assistant de contact"
        className="fixed bottom-24 right-5 z-[60] flex h-14 w-14 items-center justify-center rounded-full border border-[#C9A84C] bg-[#2C2C2C] text-white shadow-xl transition-transform duration-300 hover:scale-105 hover:bg-[#C9A84C] hover:text-[#2C2C2C] lg:bottom-5"
      >
        {open ? <X size={24} /> : <MessageCircle size={24} />}
      </button>
    </>
  );
}
